// extracted by mini-css-extract-plugin
export var counter = "Desktop-module--counter--ba1c5";
export var fadeInAnimation = "Desktop-module--fadeInAnimation--4d40c";
export var group = "Desktop-module--group--05714";
export var groupTitle = "Desktop-module--groupTitle--e2064";
export var hint = "Desktop-module--hint--19cea";
export var label = "Desktop-module--label--49c62";
export var title = "Desktop-module--title--f3d7f";
export var withHintImage = "Desktop-module--withHintImage--d4dc8";